import * as React from 'react';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';

interface IProps {
	context: any;
}

class RegisterComponent extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public componentDidMount() {
		const { signinRedirectJoin } = this.props.context;
		signinRedirectJoin();
	}

	public render() {
		return <></>;
	}
}

const Register = withAuthContext(RegisterComponent);

export { Register };
